var ShareSpaceModelImpl_1;
import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { FOREVER_TS } from '../../constants';
import { SpaceOrFolder } from '../../enums';
let ShareSpaceModelImpl = ShareSpaceModelImpl_1 = class ShareSpaceModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = ShareSpaceModelImpl_1.getDefaultValue();
    }
    static getDefaultValue() {
        return {
            shareExpiryAt: FOREVER_TS,
            syncDisplayField: false,
            type: SpaceOrFolder.SPACE,
            spaceId: '',
            folderId: undefined,
            spaceName: '',
            folderName: undefined,
            spaceS3Key: undefined,
            spaceIcon: undefined,
            enableShareSpace: false,
            enableShareFolder: false,
            spaceType: undefined,
        };
    }
    reset() {
        this.update(() => ShareSpaceModelImpl_1.getDefaultValue());
    }
};
ShareSpaceModelImpl = ShareSpaceModelImpl_1 = __decorate([
    injectable()
], ShareSpaceModelImpl);
export { ShareSpaceModelImpl };
